import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FieldData } from 'rc-field-form/lib/interface';
import { Form, InputProps, Select } from 'antd';
import Search from 'antd/lib/input/Search';

import {
  PricingRouteContractListParams,
  PricingRoutes,
  SearchContracts,
} from 'pricing/types';
import { ContractSearchStyled } from './contractSearch.styles';

const { Option } = Select;

const searchOptions = [
  {
    name: 'Contract Id',
    value: SearchContracts.ContractId,
  },
  {
    name: 'Breeder Id',
    value: SearchContracts.BreederId,
  },
  {
    name: 'Breeder Name',
    value: SearchContracts.BreederName,
  },
];

export function ContractSearch(): ReactElement {
  const [inputType, setInputType] = useState<InputProps['type']>('number');
  const params: PricingRouteContractListParams = useParams();
  const history = useHistory();
  const [form] = Form.useForm();

  const handleFieldChange = (changedFields: FieldData[]) => {
    const [{ name, value }] = changedFields;

    if (typeof name === 'object') {
      if (name[0] === 'searchCategory') {
        form.resetFields(['searchQuery']);
        handleSetInputType(value);
      }
    }
  };

  const handleSetInputType = (value: string) => {
    if (value === SearchContracts.ContractId || value === SearchContracts.BreederId) {
      setInputType('number');
    }
    if (value === SearchContracts.BreederName) {
      setInputType('text');
    }
  };

  const handleOnSearch = async (value: string) => {
    const searchCategory = form.getFieldValue('searchCategory');

    if (value) {
      history.push(`${PricingRoutes.ContractList}/${searchCategory}/${value}`);
    } else {
      history.push(`${PricingRoutes.ContractList}`);
    }
  };

  useEffect(() => {
    if (params.category || params.query) {
      if (params.category === SearchContracts.BreederName) {
        setInputType('text');
      }
      form.setFieldsValue({ searchCategory: params.category, searchQuery: params.query });
    } else {
      form.resetFields();
    }
  }, [params.category, params.query]);

  return (
    <ContractSearchStyled data-testid="contract-search">
      <Form
        layout="inline"
        form={form}
        onFieldsChange={handleFieldChange}
        initialValues={{ searchCategory: SearchContracts.BreederId }}
      >
        <Form.Item className="search-type" name="searchCategory">
          <Select placeholder="Search By" data-testid="contract-search-dropdown">
            {searchOptions.map((option) => (
              <Option
                value={option.value}
                key={option.value}
                data-testid={`contract-search-dropdown-option-${option.value}`}
              >
                {option.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item className="search-value" name="searchQuery">
          <Search
            data-testid="contract-search-input"
            placeholder="Search"
            allowClear
            onSearch={handleOnSearch}
            type={inputType}
            autoComplete="off"
          />
        </Form.Item>
      </Form>
    </ContractSearchStyled>
  );
}
